import { Flex } from "@/v1/components/atoms/Flex/Flex";
import { Form } from "@/v1/components/atoms/Form/Form";
import { FormProvider } from "@/v2/context/FormContext";
import { ITestNewsletterBody } from "@/v2/service/testNewsletterService";

import { NewsletterEmailField } from "../../organisms/NewsletterEmailField/NewsletterEmailField";
import { NewsletterModalMessage } from "../../organisms/NewsletterModalMessage/NewsletterModalMessage";
import { NewsletterOperatorsSelect } from "../../organisms/NewsletterOperatorsSelect/NewsletterOperatorsSelect";
import { NewsletterTypeSelect } from "../../organisms/NewsletterTypeSelect/NewsletterTypeSelect";

interface TestNewsletterFormProps {
  handleSubmit: (body: ITestNewsletterBody) => Promise<void>;
}
export const TestNewsletterForm: React.FC<TestNewsletterFormProps> = ({ handleSubmit }) => {
  return (
    <FormProvider>
      <Form id="test-newsletter" onSuccess={handleSubmit}>
        <Flex container flexDirection="column" gap={4}>
          <NewsletterModalMessage />
          <NewsletterOperatorsSelect />
          <NewsletterTypeSelect />
          <NewsletterEmailField />
        </Flex>
      </Form>
    </FormProvider>
  );
};
